import React from 'react';
import {Button} from "@deere/ux.uxframe-react";
import {format, parseISO} from "date-fns";
import ExcelJS from "exceljs";

const ExportClaimDetails = ({claim}) => {

    const formatDateForExport = (date) => {
        if (date) {
            const parsedDate = parseISO(date);
            return format(parsedDate, 'dd MMM yyyy');
        } else {
            // Handle the case where date is undefined or null
            return 'N/A'; // Or any other default value you prefer
        }
    }
    const handleClaimExport = async () => {
        // Create an Excel Workbook
        const workbook = new ExcelJS.Workbook();
        // Create and add a sheet for claim information
        const claimDetailSheet = workbook.addWorksheet("ClaimInformation");

        const claimDetails = [
            ["Claim #", claim.claimNumber],
            ["Claim Type", claim.claimType],
            ["Dealer Account #", claim?.dealer?.dealerNumber],
            ["Customer", claim.customerName],
            ["Reference # 1", claim.reference1],
            ["Reference # 2", claim.reference2],
            ["Ownership Status", claim.ownershipStatus],
            ["Repair / Install Date",],
            ["Serial #",],
            ["PIN #", claim.pinNumber],
            ["Model", claim.model],
            ["Measurement", claim.measurement ?? 0],
            ["Failure Date", formatDateForExport(claim.failureDate)],
            ["Repair Date", formatDateForExport(claim.repairDate)],
            ["Process Date", formatDateForExport(claim.processDate)],
            ["Credit Memo", claim.creditMemo],
            ["Failure Part Serial #", claim.failurePartSerialNumber],
            ["Failure Information"],
            [""],
            [`Failure Part : ${claim.failurePartSerialNumber}`],
            [""],
            ["Failure Mode", claim.failureMode?.join(" ")],
            ["Failure Area", claim?.failureArea?.join(" ")],
            ["Failure Mode Comments ", claim?.failureModeComments?.join(" ")],
            ["Downtime", claim?.downtime?.join(" ")],
            ["Previous Invoice #", claim?.claimDetailDTOList[0].prv_invoice_wo_num],
            ["DTAC Case", claim?.dtacCaseNumber?.join(" ")],
            ["DTAC Solution", claim?.dtacSolution?.join(" ")],
        ];

        const creditHeader = [
            ["Parts  / Labor  / Other Credits "],
            [""],
            ["", "Item", "Description", "Quantity Approved"]
        ];

        /*An empty string is added as first element to display data from the second column*/
        const rplcPartData = claim?.claimReplacementPartList?.map(
            ({rplc_part_num, part_name_dsc, requested_part_cnt}) => [
                "", rplc_part_num, part_name_dsc, requested_part_cnt
            ]);

        const laborData = claim?.laborList?.map(
            ({laborNumber, laborDescription, quantityApproved}) => [
                "", laborNumber, laborDescription, quantityApproved
            ]);

        const otherCreditData = claim?.otherCreditsList?.map(
            ({rplc_part_num, part_name_dsc, requested_part_cnt}) => [
                "", rplc_part_num, part_name_dsc, requested_part_cnt
            ]);

        const compCauseCorrectionData = [
            [""],
            ["Complaint", claim?.complaintStr],
            [""],
            ["Cause", claim?.causeStr],
            [""],
            ["Correction", claim?.correctionStr]
        ];

        /*Add Claim and Other Details to the created Sheet*/
        claimDetails?.forEach((rowData) => {
            const row = claimDetailSheet.addRow(rowData);
            row.getCell(1).style.font = {bold: true};
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.style.alignment = {horizontal: "left"};
            })
        });

        creditHeader?.forEach((rowData) => {
            const row = claimDetailSheet.addRow(rowData);
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: "left"};
            });
        });

        rplcPartData?.forEach((rowData) => {
            const row = claimDetailSheet.addRow(rowData);
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.style.alignment = {horizontal: "left"};
            });
        });

        laborData?.forEach((rowData) => {
            const row = claimDetailSheet.addRow(rowData);
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.style.alignment = {horizontal: "left"};
            });
        });

        otherCreditData?.forEach((rowData) => {
            const row = claimDetailSheet.addRow(rowData);
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.style.alignment = {horizontal: "left"};
            });
        });

        compCauseCorrectionData?.forEach((rowData) => {
            const row = claimDetailSheet.addRow(rowData);
            row.getCell(1).style.font = {bold: true};
            row.eachCell({includeEmpty: true}, (cell) => {
                cell.style.alignment = {horizontal: "left"};
            });
        });

        // Setting default column width for the columns in the Sheet
        claimDetailSheet.getColumn(1).width = 30;
        claimDetailSheet.getColumn(2).width = 30;
        claimDetailSheet.getColumn(3).width = 30;
        claimDetailSheet.getColumn(4).width = 30;

        /*Create a Blob to store the Excel file*/
        const blob = await workbook.xlsx.writeBuffer();

        /*Create a download link for this file and trigger the download programmatically*/
        const blobUrl = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = `${(claim?.claimNumber + "_" + claim?.pinNumber).toUpperCase()}.xlsx`
        a.click();
        window.URL.revokeObjectURL(blobUrl);
    }

    return (
        <Button variant={"secondary"} onClick={handleClaimExport}>
            Export To Excel
        </Button>
    );
};

export default ExportClaimDetails;
